import { auth } from '@/firebaseConfig'
import PublisherService from '@/service/PublisherService.js'

export default class AuthenticationService {
    constructor(store) {
        this.store = store;
    }

    initialize() {
        const selfStore = this.store;

        auth.onAuthStateChanged(function(user) {
            if (user) {
                selfStore.commit('setCurrentUser', user);

                const publisherService = new PublisherService();
                publisherService.loadPublishersForUser(user.uid).then((publishers) => {
                    var currentPublisherValid = false;

                    const currentPublisher = selfStore.state.currentPublisher;
                    if (currentPublisher) {
                        for (const publisher of publishers) {
                            if (publisher.id == currentPublisher.id) {
                                currentPublisherValid = true;
                                break;
                            }
                        }
                    }

                    if (!currentPublisherValid && publishers && publishers.length > 0) {
                        selfStore.commit('setCurrentPublisher', publishers[0]);
                    }
                }).catch(() => {
                    // Nothing to do
                });
            } else {
                selfStore.commit('setCurrentUser', null);
            }
        })
    }

    login(email, password) {
        const promise = new Promise((resolve, reject) => {
            auth.signInWithEmailAndPassword(email, password).then((user) => {
                this.store.commit('setCurrentUser', user.user)
                this.store.dispatch('fetchUserProfile')
                resolve(user.user);
            }).catch((error) => {
                reject(error);
            });
        });
        return promise;
    }

    logout() {
        const promise = new Promise((resolve, reject) => {
            this.store.commit('setCurrentUser', null);
            auth.signOut().then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    getAuthenticatedUser() {
        return auth.user;
    }
}